/**
 * Fleet Overview — Frontend ローカル Contract
 *
 * BE 側 `dresscode-backend/v2/src/ga-force/api/fleet-overview/usecase/fleet-overview.api-contract.ts`
 * と同じ Zod 構造を再現。BE が `@standandforce/api-contract` に publish された後、
 * client.ts でローカル import を置き換える想定。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const FleetStatusValueSchema = z.enum(['ACTIVE', 'INACTIVE', 'MAINTENANCE', 'DECOMMISSIONED', 'DISPOSED']);
const FleetVehicleTypeValueSchema = z.enum(['SHIP', 'VEHICLE', 'AIRCRAFT']);
const FleetOverviewCountSchema = z.object({
  total: z.number(),
  active: z.number(),
  maintenance: z.number(),
  inactive: z.number(),
  byStatus: z.array(z.object({
    status: FleetStatusValueSchema,
    count: z.number()
  })),
  byStatusAndType: z.array(z.object({
    status: FleetStatusValueSchema,
    fleetType: FleetVehicleTypeValueSchema,
    count: z.number()
  })),
  byOwnershipType: z.array(z.object({
    ownershipType: z.string(),
    count: z.number()
  }))
});
const FleetOverviewTimeSeriesPointSchema = z.object({
  month: z.string(),
  cumulativeCount: z.number(),
  addedCount: z.number()
});
const FleetOverviewTimeSeriesSchema = z.object({
  monthly: z.array(FleetOverviewTimeSeriesPointSchema)
});
const FleetOverviewActivityItemSchema = z.object({
  fleetId: z.string(),
  fleetName: z.string(),
  fleetType: FleetVehicleTypeValueSchema,
  occurredAt: z.string()
});
const FleetOverviewActivitySchema = z.object({
  recent: z.array(FleetOverviewActivityItemSchema)
});
export const fleetOverviewContract = oc.router({
  count: oc.route({
    method: 'GET',
    path: '/v2/fleet-overview/count'
  }).output(FleetOverviewCountSchema),
  timeSeries: oc.route({
    method: 'GET',
    path: '/v2/fleet-overview/time-series'
  }).output(FleetOverviewTimeSeriesSchema),
  recentActivity: oc.route({
    method: 'GET',
    path: '/v2/fleet-overview/recent-activity'
  }).output(FleetOverviewActivitySchema)
});
export type FleetStatusValue = z.infer<typeof FleetStatusValueSchema>;
export type FleetVehicleTypeValue = z.infer<typeof FleetVehicleTypeValueSchema>;
export type FleetOverviewCount = z.infer<typeof FleetOverviewCountSchema>;
export type FleetOverviewTimeSeries = z.infer<typeof FleetOverviewTimeSeriesSchema>;
export type FleetOverviewActivityItem = z.infer<typeof FleetOverviewActivityItemSchema>;